var BetterVits = {
  productIds: {
    8256506036532: "Glucosamine Complex",
    8256505741620: "Turmeric Complex",
    8256506167604: "Probiotic Complex",
    8256506200372: "Magnesium Complex",
    8256506102068: "Multivitamin",
    6873016598704: "Niacinamide",
    8256505807156: "Vitamin D3 & K2",
    8256505184564: "Marine Collagen Complex",
    8256505053492: "Menopause Complex",
    7119209234608: "PMS Complex",
    7119209955504: "Vitamin C",
    7231608455344: "Apple Cider Vinegar",
    8256504529204: "Ashwagandha",
    8256504267060: "Berberine",
    8256504365364: "Biotin Complex",
    7250764267696: "Kids Multivitamin",
    7250764497072: "Kids Probiotic",
    7250764824752: "Omega 3",
    7328448118960: "Coenzyme Q10",
    7328448544944: "Evening Primrose Oil",
    7328448446640: "Zinc",
    7328449069232: "Sound Asleep",
    9079870619956: "Odorless Garlic",
    9269766783284: "Creatine"
  },
  getProductVariant: {
    8256506036532: 45005138428212,
    8256506200372: 45005138624820,
    8256506102068: 45005138526516,
    6873016598704: 40607289475248,
    8256506167604: 45005138592052,
    8256505807156: 45005138198836,
    8256505741620: 45005138133300,
    8256505184564: 45005137412404,
    8256505053492: 45005137150260,
    7119209234608: 41746379899056,
    7119209955504: 41746382192816,
    7231608455344: 42145153777840,
    8256504529204: 45005134168372,
    8256504267060: 45005133709620,
    8256504365364: 45005133807924,
    7250764267696: 42229896446128,
    7250764497072: 42229897167024,
    7250764824752: 42229898150064,
    7328448118960: 42638975893680,
    7328448544944: 42638978023600,
    7328448446640: 42638977564848,
    7328449069232: 42638978711728,
    9079870619956: 47953755701556,
    9269766783284: 48883305218356
  },
  productImage: {
    "Glucosamine Complex": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-glucosamine-shadeless_x200.png?v=1698070629",
    "Magnesium Complex": "https://bettervits.com/cdn/shop/products/Mag_400x620.png?v=1682877442",
    Multivitamin: "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-multivitamin-shadeless_x200.png?v=1698070788",
    Niacinamide: "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-niacinamide-shadeless_x200.png?v=1698070819",
    "Probiotic Complex": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-probiotic-shadeless_x200.png?v=1698070906",
    "Vitamin D3 & K2": "https://bettervits.com/cdn/shop/products/product-d3-1_400x620.png?v=1682877412",
    "Turmeric Complex": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-turmeric-shadeless_x200.png?v=1698070994",
    "Marine Collagen Complex": "https://bettervits.com/cdn/shop/files/collagen-cover_a9d068f3-e9e7-456c-a1df-ac1fe8dab819_600x820.png?v=1713513104",
    "Menopause Complex": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-menopause-shadeless_x200.png?v=1698070762",
    "PMS Complex": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-pms-shadeless_x200.png?v=1698070881",
    "Vitamin C": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-vitamin-c-shadeless_x200.png?v=1698071036",
    "Apple Cider Vinegar": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-acv-gummies-shadeless_x200.png?v=1698070407",
    Ashwagandha: "https://bettervits.com/cdn/shop/products/product-ashwagandha-1_x190.png?v=1682877354",
    Berberine: "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-berberine-shadeless_x200.png?v=1698070501",
    "Biotin Complex": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-biotin-shadeless_x200.png?v=1698070536",
    "Kids Multivitamin": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-kids-multivitamin-shadeless_x200.png?v=1698070661",
    "Kids Probiotic": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-kids-probiotic-shadeless_x200.png?v=1698070685",
    "Omega 3": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-omega-3-shadeless_x200.png?v=1698070857",
    "Coenzyme Q10": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-coq10-shadeless_x200.png?v=1698070560",
    "Evening Primrose Oil": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-primrose-oil-shadeless_x200.png?v=1698070611",
    Zinc: "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-zinc-shadeless_x200.png?v=1698071084",
    "Sound Asleep": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-sleep-shadeless_x200.png?v=1698070938",
    Creatine: "https://bettervits.com/cdn/shop/files/creatine-cover_06ef4c6d-6e03-4738-ae8b-34518ac6cf5a_400x620.png?v=1757087819",
    "Odorless Garlic": "https://bettervits.com/cdn/shop/files/garlic-shaded_400x620.png?v=1715257529"
  },
  getDiscountedProductsName: {
    8256505839924: "Glucosamine Complex",
    8256505086260: "Turmeric Complex",
    8256506003764: "Probiotic Complex",
    8256505872692: "Magnesium Complex",
    8256505905460: "Multivitamin",
    6875450572976: "Niacinamide",
    8256505774388: "Vitamin D3 & K2",
    8256505119028: "Marine Collagen Complex",
    8256504987956: "Menopause Complex",
    7119209496752: "PMS Complex",
    7119210414256: "Vitamin C",
    7250763710640: "Apple Cider Vinegar",
    8256504496436: "Ashwagandha",
    8256504234292: "Berberine",
    8256504332596: "Biotin Complex",
    7250764333232: "Kids Multivitamin",
    7250764529840: "Kids Probiotic",
    7250764890288: "Omega 3",
    7328448250032: "Coenzyme Q10",
    7328449003696: "Evening Primrose Oil",
    7328448479408: "Zinc",
    7328449167536: "Sound Asleep",
    9079871013172: "Odorless Garlic",
    9269773369652: "Creatine"
  },
  getDiscountedProductID: {
    // regular product ID : discounted product ID
    8256506036532: 8256505839924,
    8256505741620: 8256505086260,
    8256506167604: 8256506003764,
    8256506200372: 8256505872692,
    8256506102068: 8256505905460,
    6873016598704: 6875450572976,
    8256505807156: 8256505774388,
    8256505184564: 8256505119028,
    8256505053492: 8256504987956,
    7119209234608: 7119209496752,
    7119209955504: 7119210414256,
    7231608455344: 7250763710640,
    8256504529204: 8256504496436,
    8256504267060: 8256504234292,
    8256504365364: 8256504332596,
    7250764267696: 7250764333232,
    7250764497072: 7250764529840,
    7250764824752: 7250764890288,
    7328448118960: 7328448250032,
    7328448544944: 7328449003696,
    7328448446640: 7328448479408,
    7328449069232: 7328449167536,
    9079870619956: 9079871013172,
    9269766783284: 9269773369652
  },
  getDiscountedProductVariant: {
    // discounted product ID: discounted product variant ID
    8256505839924: 45005138231604,
    8256505872692: 45005138264372,
    8256505905460: 45005138297140,
    6875450572976: 40617577087152,
    8256506003764: 45005138395444,
    8256505774388: 45005138166068, // D3
    8256505086260: 45005137183028,
    8256505119028: 45005137215796, // Collagen
    8256504987956: 45005137084724,
    7119209496752: 41746380521648,
    7119210414256: 41746383044784,
    7250763710640: 42229894381744,
    8256504496436: 45005134135604,
    8256504234292: 45005133676852,
    8256504332596: 45005133775156,
    7250764333232: 42229896609968,
    7250764529840: 42229897298096,
    7250764890288: 42229898281136,
    7328448250032: 42638976614576,
    7328449003696: 42638978646192,
    7328448479408: 42638977597616,
    7328449167536: 42638978810032,
    9079871013172: 47953756586292,
    9269773369652: 48883313606964
  },
  mapDiscounts: {
    // regular product ID : discounted product ID
    8256506036532: 8256506003764,
    8256506200372: 8256505872692, // Magnesium - Magensium
    8256506102068: 8256506003764, // Multivitamin's upsell is Probiotic
    6873016598704: 8256506003764,
    8256506167604: 8256506003764,
    8256505807156: 8256505774388, // Vitamin D3 & K2 - D3
    8256505741620: 8256506003764,
    8256505184564: 8256505119028, // Collagen - Collagen
    8256505053492: 8256506003764,
    7119209234608: 8256506003764,
    7119209955504: 8256506003764,
    7231608455344: 8256506003764, // ACV's upsell is Probiotic
    8256504529204: 8256504496436, // Ashwagandha's upsell is Ashwagandha
    8256504267060: 8256504234292, // BC's upsell is BC
    8256504365364: 8256506003764, // Biotin - Probiotic
    7250764267696: 8256506003764, // Kids Multivitamin - Kids Probiotic
    7250764497072: 8256506003764, // Kids Probiotic - Kids Multivitamin
    7250764824752: 8256506003764, // Omega 3 - Probiotic
    7328448118960: 8256506003764, // C10 - Multivitamin
    7328448544944: 8256506003764, // Primrose - Multivitamin
    7328448446640: 8256506003764, // Zinc - Magnesium
    7328449069232: 8256506003764, // Sleep - ACV
    9079870619956: 9079871013172, // OG - OG
    9269766783284: 9269773369652 // Creatine - Creatine
  },

  productsSelingPlans: {
    45005138428212: [690149589300, 690347114804, 690347147572], // Glucosamine
    45005138592052: [690347245876, 690347180340, 690347213108], // Probiotic
    45005138133300: [690347082036, 690347016500, 690347049268], // Turmeric
    45005137412404: [690406326580, 690406261044, 690406293812], // Collagen
    45005138624820: [690405867828, 690405900596, 690405933364], // Magnesium
    40607289475248: [752910512, 789807280, 789840048], // Niacinamide
    45005138526516: [692619215156, 692619247924, 692619280692,], // Multivitamin
    45005138198836: [690406097204, 690406129972, 690406064436], // Vitamin D3 & K2
    45005137150260: [692619018548, 692619084084, 692619051316], // Menopause
    41746379899056: [923959472, 924156080, 924188848], // PMS Complex
    41746382192816: [923926704, 924025008, 924057776], // Vitamin C
    42145153777840: [1060995248, 1061322928, 1061355696], // ACV
    45005134168372: [690406654260, 690406687028, 690406719796], // Ashwagandha
    45005133709620: [690406457652, 690406490420, 690406523188], // BC
    45005133807924: [692618821940, 692618854708, 692618887476,], // Biotin
    42229896446128: [1061159088, 1061847216, 1061879984], // Kids Multivitamin
    42229897167024: [1060929712, 1061978288, 1062011056], // Kids Probiotic
    42229898150064: [1061191856, 1062142128, 1062174896], // Omega 3
    42638975893680: [1122042032, 1122140336, 1122173104], // C10
    42638978023600: [1122107568, 1122271408, 1122304176], // Primrose
    42638977564848: [1122533552, 1122566320, 1122599088], // Zinc
    42638978711728: [1122730160, 1122762928, 1122795696], // Sleep
    47953755701556: [690523046196, 690523013428, 690522980660], // OG
    48883305218356: [692581400884, 692581433652, 692581466420] // Creatine
  },
  offersSellingPlans: {
    45005137215796: [690406359348, 690406392116, 690406424884], // Collagen
    45005138231604: [690347344180, 690357928244, 690357895476], // Glucosamine
    45005138264372: [690405966132, 690405998900, 690406031668], // Magnesium
    45005138297140: [692619116852, 692619149620, 692619182388,], // Multivitamin
    40617577087152: [789282992, 789872816, 789905584], // Niacinamide
    45005138395444: [690347278644, 690357961012, 690357993780], // Probiotic
    45005137183028: [690347311412, 690358026548, 690358059316], // Turmeric
    45005138166068: [690406162740, 690406195508, 690406228276], // Vitamin D3 & K2
    45005137084724: [692618953012, 692618920244, 692618985780,], // Menopause
    41746380521648: [923893936, 924221616, 924254384], // PMS Complex
    41746383044784: [923992240, 924090544, 924123312], // Vitamin C
    42229894381744: [1061060784, 1061388464, 1061421232], // ACV
    45005134135604: [690406785332, 690406752564, 690406818100], // Ashwagandha
    45005133676852: [690406621492, 690406588724, 690406555956], // BC
    45005133775156: [692618723636, 692618756404, 692618789172,], // Biotin
    42229896609968: [1061290160, 1061912752, 1061945520], // Kids Multivitamin
    42229897298096: [1062043824, 1062076592, 1062109360], // Kids Probiotic
    42229898281136: [1062207664, 1062240432, 1062273200], // Omega 3
    42638976614576: [1122074800, 1122205872, 1122238640], // C10
    42638978646192: [1122336944, 1122369712, 1122402480], // Primrose
    42638977597616: [1122435248, 1122468016, 1122500784], // Zinc
    42638978810032: [1122631856, 1122664624, 1122697392], // Sleep
    47953756586292: [690523111732, 690523078964, 690523144500,], // OG
    48883313606964: [692581499188, 692581531956, 692581564724,] // Creatine
  }, 
  isSafari: !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/),
  iOS: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
  cornerElement: document.querySelector(".green-section--tocorner"),
  initCarsousels: () => {
    if (document.getElementById("bestsellers-slider")) {
      new Splide("#bestsellers-slider", {
        type: "loop",
        perPage: 3,
        gap: window.innerWidth <= 1024 ? 24 : 80,
        speed: 333,
        easing: "cubic-bezier(0.55, 0.24, 0.52, 1.0)",
        autoplay: false,
        interval: 6000,
        padding: window.innerWidth <= 1024 ? 0 : 80,
        pagination: false,
        arrows: true,
        arrowPath:
          "M2.5,17.7c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2V17.7z M39.1,21.6c0.9-0.9,0.9-2.3,0-3.2L24.9,4.2 c-0.9-0.9-2.3-0.9-3.2,0c-0.9,0.9-0.9,2.3,0,3.2L34.4,20L21.8,32.6c-0.9,0.9-0.9,2.3,0,3.2c0.9,0.9,2.3,0.9,3.2,0L39.1,21.6z M2.5,22.2h35.1v-4.5H2.5V22.2z",
        breakpoints: {
          767: {
            perPage: 2,
          },
          1024: {
            perPage: 3,
          },
        },
      }).mount();
    }
    if (document.getElementById("testimonials-slider")) {
      if (window.innerWidth >= 767) {
        document.querySelectorAll("#testimonials-slider li.mobile-show").forEach((button) => {
          button.remove();
        });
      } else {
        document.querySelectorAll("#testimonials-slider li:not(.mobile-show)").forEach((button) => {
          button.remove();
        });
      }
      var splide = new Splide("#testimonials-slider", {
        type: "loop",
        perPage: 1,
        gap: 30,
        speed: 700,
        easing: "cubic-bezier(0.55, 0.24, 0.52, 1.0)",
        autoplay: false,
        interval: 600000,
        padding: 0,
        updateOnMove: true,
        pagination: false,
        arrows: true,
        autoHeight: true,
        breakpoints: {
          767: {
            perPage: 1,
          },
          1200: {
            perPage: 2,
          },
        },
        arrowPath:
          "M2.5,17.7c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2V17.7z M39.1,21.6c0.9-0.9,0.9-2.3,0-3.2L24.9,4.2 c-0.9-0.9-2.3-0.9-3.2,0c-0.9,0.9-0.9,2.3,0,3.2L34.4,20L21.8,32.6c-0.9,0.9-0.9,2.3,0,3.2c0.9,0.9,2.3,0.9,3.2,0L39.1,21.6z M2.5,22.2h35.1v-4.5H2.5V22.2z",
      }).mount();

      if (window.innerWidth < 767) {
        splide.on("mounted", function () {
          console.log("mounted");

          var nodes = document.querySelectorAll("li.splide__slide.is-active.is-visible");
          var last = nodes[nodes.length - 1];

          document.getElementById("testimonials-slider-track").style.maxHeight = last.querySelector(".testimonials__card").offsetHeight + 10 + "px";
          console.log("executed");

          splide.mount();
        });
        splide.on("moved", function () {
          var nodes = document.querySelectorAll("li.splide__slide.is-active.is-visible");
          var last = nodes[nodes.length - 1];

          document.getElementById("testimonials-slider-track").style.maxHeight = last.querySelector(".testimonials__card").offsetHeight + 10 + "px";
        });
      }
    }
    if (document.getElementById("product-slider")) {
      new Splide("#product-slider", {
        type: "loop",
        perPage: 1,
        gap: 0,
        speed: 700,
        easing: "cubic-bezier(0.55, 0.24, 0.52, 1.0)",
        autoplay: false,
        interval: 600000,
        padding: 0,
        updateOnMove: true,
        pagination: true,
        arrows: true,
        arrowPath:
          "M1 4.65684C0.668629 4.65684 0.4 4.92547 0.4 5.25684C0.4 5.58821 0.668629 5.85684 1 5.85684V4.65684ZM28.4243 5.6811C28.6586 5.44679 28.6586 5.06689 28.4243 4.83257L24.6059 1.01419C24.3716 0.779881 23.9917 0.779881 23.7574 1.01419C23.523 1.24851 23.523 1.62841 23.7574 1.86272L27.1515 5.25684L23.7574 8.65095C23.523 8.88526 23.523 9.26516 23.7574 9.49948C23.9917 9.73379 24.3716 9.73379 24.6059 9.49948L28.4243 5.6811ZM1 5.85684H28V4.65684H1V5.85684Z",
        breakpoints: {
          767: {
            perPage: 1,
          },
          1024: {
            perPage: 1,
          },
        },
      }).mount();
    }
    if (document.getElementById("ingredients-slider")) {
      new Splide("#ingredients-slider", {
        type: "loop",
        gap: 30,
        speed: 700,
        perPage: 1,
        easing: "cubic-bezier(0.55, 0.24, 0.52, 1.0)",
        autoplay: false,
        interval: 600000,
        padding: 30,
        updateOnMove: false,
        pagination: false,
        arrows: true,
        dots: false,
        arrowPath:
          "M2.5,17.7c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2V17.7z M39.1,21.6c0.9-0.9,0.9-2.3,0-3.2L24.9,4.2 c-0.9-0.9-2.3-0.9-3.2,0c-0.9,0.9-0.9,2.3,0,3.2L34.4,20L21.8,32.6c-0.9,0.9-0.9,2.3,0,3.2c0.9,0.9,2.3,0.9,3.2,0L39.1,21.6z M2.5,22.2h35.1v-4.5H2.5V22.2z",
        breakpoints: {
          650: {
            perPage: 1,
          },
          768: {
            perPage: 2,
          },
          1200: {
            perPage: 3,
          },
        },
      }).mount();
    }
  },
  isElementInView: (el) => {
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;
    var isVisible = elemTop >= 0 && elemBottom <= window.innerHeight;
    return isVisible;
  },
  customSticky: () => {
    if (window.scrollY >= 10) {
      document.querySelector("header.header").classList.add("header--sticky");
    } else {
      document.querySelector("header.header").classList.remove("header--sticky");
    }
  },
  initMobileMenu: () => {
    document.querySelector(".header__toggle").addEventListener("click", function (ev) {
      ev.preventDefault();
      document.querySelector(".header__nav").classList.toggle("active");
    });
  },
  initFAQ: () => {
    var questions = document.querySelectorAll(".faqs__list-question");
    for (var j = 0; j < questions.length; j++) {
      questions[j].addEventListener("click", function (ev) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        ev.stopPropagation();
        var that = this;
        if (that.classList.contains("active")) {
          that.nextElementSibling.classList.remove("active");
          that.classList.remove("active");
        } else {
          var answers = document.querySelectorAll(".faqs__list-answer");

          for (var i = 0; i < answers.length; i++) {
            answers[i].classList.remove("active");
          }

          for (var j = 0; j < questions.length; j++) {
            questions[j].classList.remove("active");
          }

          that.classList.add("active");
          that.nextElementSibling.classList.add("active");
        }
      });
    }
  },
  cartUpsellInit: (quantity, metaproduct, isCart) => {
    var productID = metaproduct.id;
    var variantID = metaproduct.variants[0].id;
    var isSub;
    var quantity = parseInt(quantity);
    var upsellID = isCart ? BetterVits.getDiscountedProductID[productID] : BetterVits.mapDiscounts[productID],
      upsellName = BetterVits.getDiscountedProductsName[upsellID],
      upsellImage = BetterVits.productImage[upsellName],
      upsellElement = document.querySelector(".upsell"),
      upsellTitle = "",
      upsellContent = "",
      upsellTitleElement = document.querySelector(".upsell b"),
      upsellContentElement = document.querySelector(".upsell p"),
      isCreatine = variantID == 42887457145008,
      upsellImageElement = document.querySelector(".upsellimg");

    if (isCart) {
      upsellElement = document.querySelector(".cart-items__item--upsell");
      (upsellTitleElement = document.querySelector(".cart-items__item--upsell h4 span:not(.orange)")),
        (upsellContentElement = document.querySelector(".cart-items__item--upsell p")),
        (upsellImageElement = document.querySelector(".cart-items__item--upsell .cart-items__item-image img"));
    }
    upsellElement.classList.add("hidden");

    switch (upsellName) {
      case "Multivitamin":
        upsellTitle = "Add a Multivitamin For $16.99?";
        upsellContent = "Use this balanced everyday multivitamin to boost your health & energy alongside your purchase!";
        break;
      case "Kids Multivitamin":
        upsellTitle = "Add a Kids Multivitamin For $25?";
        upsellContent = "Use this balanced everyday multivitamin to boost your kids health & energy alongside your purchase!";
        break;
      case "Kids Probiotic":
        upsellTitle = "Add Our Kids Probiotic For Just $25?";
        upsellContent = "Get 50% off our Kids Probiotic and start improving your kids gut health today!";
        break;
      case "Magnesium Complex":
        upsellTitle = "Add Our Magnesium For $25?";
        upsellContent = "<b>Offer Unlocked!</b> Try our powerfully enriching Magnesium supplement for 33% off today.";
        break;
      case "Probiotic Complex":
        upsellTitle = "Add Our Probiotic For Just $25?";
        upsellContent = "Get 50% off our Probiotic Complex and start improving your gut health today!";
        break;
      case "Vitamin D3 & K2":
        upsellTitle = "Add Our Vitamin D3 & K2 For Just $25?";
        upsellContent = "Get 50% off our Vitamin D3 & K2 and start improving your health today!";
        break;
      case "Apple Cider Vinegar":
        upsellTitle = "Add ACV Gummies For $25?";
        upsellContent = "Get 50% off these delicious Apple Cider Vinegar gummies to help boost digestion & weight loss.";
        break;
      default:
        upsellTitle = "Add 1 More For Just $25!";
        upsellContent = "Save 50% with this limited time offer and get longer lasting results.";
    }
    if (isCart) {
      upsellElement = document.querySelector(".cart-items__item--upsell");
      (upsellTitleElement = document.querySelector(".cart-items__item--upsell h4 span:not(.orange)")),
        (upsellContentElement = document.querySelector(".cart-items__item--upsell p")),
        (upsellImageElement = document.querySelector(".cart-items__item--upsell .cart-items__item-image img"));
    }
    if (!isCart) {
      if (parseInt(quantity) <= 7) {
        upsellID = BetterVits.getDiscountedProductID[productID];
        upsellName = BetterVits.getDiscountedProductsName[upsellID];
        upsellImage = BetterVits.productImage[upsellName];
        upsellTitle = "Add 1 More For Just $25.00!";
        // "Add Another Jar For Just " +
        // (upsellName == "Multivitamin" ? "$16.99!" : "$25!");
        if (upsellName.toLowerCase().indexOf("kids") > -1) {
          upsellContent = `Give your kids longer lasting results and save by adding an extra bottle of our ${upsellName}.`;
        } else {
          upsellContent = `Give yourself longer lasting results and save by adding an extra bottle of our ${upsellName}.`;
        }
      }
    }
    upsellElement.classList.remove(
      "multivitamin",
      "probiotic",
      "vitamin-d3-k2",
      "probiotic-complex",
      "magnesium-complex",
      "glucosamine-complex",
      "niacinamide",
      "vitamin",
      "marine",
      "turmeric",
      "pms",
      "vitamin-c",
      "menopause",
      "ashwagandha",
      "apple",
      "kids",
      "omega",
      "berberine",
      "biotin",
      "primrose",
      "coenzyme-q10",
      "zinc",
      "asleep"
    );

    upsellElement.classList.add(upsellName.toLowerCase().split(" ")[0]);
    if (upsellName.toLowerCase().split(" ")[1]) {
      upsellElement.classList.add(upsellName.toLowerCase().split(" ")[1]);
    }

    upsellTitleElement.innerHTML = upsellTitle;
    upsellContentElement.innerHTML = upsellContent;

    if (isCart) {
      var isMulti = upsellElement.classList.contains("multivitamin");
      upsellImageElement.src = upsellImage;
      upsellTitleElement.innerHTML = `Add Another Bottle for <u>Just $${isMulti ? 16.99 : 25}?</u>`;
      upsellContentElement.innerHTML = upsellContent;
    } else {
      upsellImageElement.style.backgroundImage = "url('" + upsellImage + "')";
    }

    upsellElement.dataset.variant = upsellID;
    upsellElement.classList.remove("hidden");
    upsellElement.classList.add("active");
    document.querySelector('[action*="/cart"] [type="submit"]').addEventListener("click", function (ev) {
      ev.preventDefault();
      this.classList.add("active");
      if (document.querySelector(".upsell__check").classList.contains("active")) {
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            if (isCart) {
              window.location.href = "/checkout";
            } else {
              document.querySelector('[action*="/cart"]').submit();
            }
          }
        };
        var offerVariantId = BetterVits.getDiscountedProductVariant[upsellID];
        xhr.open("POST", "/cart/add.js", true);
        xhr.setRequestHeader("Content-Type", "application/json");

        var isSubscription = false;
        if (document.querySelector(".rc_widget__option__input--subsave")) {
          isSubscription = document.querySelector(".rc_widget__option__input--subsave").checked;
        }

        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            if (isCart) {
              window.location.href = "/checkout";
            } else {
              document.querySelector('[action*="/cart/add"]').submit();
            }
          }
        };

        xhr.send(
          JSON.stringify({
            attributes: {
              /* Promo: isCart ? "Cart Special" : "Product Special",*/
              Parent: variantID,
            },
            items: isSubscription
              ? [
                  {
                    quantity: 1,
                    selling_plan: isCart
                      ? null
                      : BetterVits.offersSellingPlans[BetterVits.getDiscountedProductVariant[parseInt(document.querySelector(".upsell").dataset.variant)]][
                          parseInt(document.querySelector("#delivery-freq").value) / 30 - 1
                        ],
                    id: BetterVits.getDiscountedProductVariant[parseInt(document.querySelector(".upsell").dataset.variant)],
                    properties: {
                      /*Promo: isCart ? "Cart Special" : "AutoShip Offer",*/
                      Parent: variantID,
                    },
                  },
                ]
              : [
                  {
                    quantity: 1,
                    id: BetterVits.getDiscountedProductVariant[upsellID],
                    properties: {
                      /*Promo: isCart ? "Cart Special" : "Product Special",*/
                      Parent: variantID,
                    },
                  },
                ],
          })
        );
      } else {
        if (isCart) {
          window.location.href = "/checkout";
        } else {
          document.querySelector('[action*="/cart"]').submit();
        }
      }
    });
  },
  initQtySelector: () => {
    var dropElement = document.querySelector(".pack-selector");
    var choices = document.querySelectorAll('[name="quantity"]');
    var types = document.querySelectorAll('[name="type"]');
    var quantityLis = document.querySelectorAll(".pack-selector li");

    for (var j = 0; j < types.length; j++) {
      types[j].addEventListener("click", function () {
        var lis = this.closest("ol").querySelectorAll("li");
        for (var l = 0; l < lis.length; l++) {
          lis[l].classList.remove("active");
        }

        this.closest("li").classList.add("active");
        dropElement.classList.remove("dropped");
        setTimeout(function () {
          var theClass = document.querySelector('[name="type"]:checked').value,
            //theChecked = document.querySelector('[name="choice"]:checked').value,
            theElement = document.querySelector(".is-" + theClass + " input");
          for (var c = 0; c < quantityLis.length; c++) {
            quantityLis[c].style.display = "none";
            if (quantityLis[c].classList.contains("is-" + theClass)) {
              quantityLis[c].style.display = "block";
            }
          }

          dropElement.classList.remove("sub", "otp");
          dropElement.classList.add(theClass);
          if (theClass == "sub") {
            document.querySelector("small.small-ships").classList.add("active");
            document.querySelector("small.monthly").classList.add("active");
            // document.querySelector(".are-you-sure").classList.remove("active");            
          } else {
            document.querySelector("small.small-ships").classList.remove("active");
            document.querySelector("small.monthly").classList.remove("active");
            // document.querySelector(".are-you-sure").classList.add("active");
          }
          theElement.removeAttribute("checked");
          theElement.dataset.checked = false;
          theElement.dispatchEvent(new Event("change"));
          var theSelector = theClass == "sub" ? "[data-label-subsave]" : "[data-label-onetime]";
          //document.querySelector(theSelector).click();
        }, 200);
      });
    }

    for (var j = 0; j < choices.length; j++) {
      choices[j].addEventListener("click", function (ev) {
        document.getElementById("addToCart").removeAttribute("disabled");
        var lis = this.closest("ul").querySelectorAll("li");
        for (var l = 0; l < lis.length; l++) {
          lis[l].classList.remove("come-first");
        }

        this.closest("li").classList.add("come-first");
        dropElement.classList.toggle("dropped");
        //dropElement.classList.add(this.value)
        document.querySelector("#Quantity-product-atf").value = this.value;
        BetterVits.cartUpsellInit(this.value, meta.product, false);
        BetterVits.updateIncentive(this.value)
      });
    }

    document.getElementById("addToCart").addEventListener("click", function (ev) {
      ev.preventDefault();
      var xhr = new XMLHttpRequest();
      var isSubscription = document.querySelector("[value='sub']").checked;
      var isOTPModalOpen = document.querySelector('#modal-container').classList.contains('open');

      if(!isSubscription && !isOTPModalOpen) {
        BetterVits.openOTPModal();
        console.log('clicked')
        return;
      }

      var items = isSubscription
        ? [
            {
              quantity: document.querySelector("input[name='upsell']").checked ? 1 : 0,
              id: BetterVits.getDiscountedProductVariant[parseInt(document.querySelector(".upsell").dataset.variant)],
              selling_plan:
                BetterVits.offersSellingPlans[BetterVits.getDiscountedProductVariant[parseInt(document.querySelector(".upsell").dataset.variant)]][
                  parseInt(document.querySelector("#delivery-freq").value) / 30 - 1
                ],
              properties: {
                /*Promo: "AutoShip Offer",*/
              },
            },
            {
              quantity: Number(document.querySelector("[name='quantity']:checked").value),
              id: meta.product.variants[0].id,
              selling_plan: BetterVits.productsSelingPlans[meta.product.variants[0].id][parseInt(document.querySelector("#delivery-freq").value) / 30 - 1],
              properties: {
                /*Promo: "AutoShip Offer",*/
              },
            },
          ]
        : [
            {
              quantity: document.querySelector("input[name='upsell']").checked ? 1 : 0,
              id: BetterVits.getDiscountedProductVariant[parseInt(document.querySelector(".upsell").dataset.variant)],
              properties: {
                /*Promo: "Product Upsell",*/
              },
            },
            {
              quantity: Number(document.querySelector("[name='quantity']:checked").value),
              id: meta.product.variants[0].id,
              properties: {
                /*Promo: "Product Upsell",*/
              },
            },
          ];
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          // window.location.href = "/cart";
          // console.log(SlideOutCart)
          document.querySelector('body').style.overflow = '';
          document.querySelector('#modal-container').innerHTML = "";
          document.querySelector('#modal-container').classList.remove('open');
          new SlideOutCart().openCart()

        }
      };

      xhr.open("POST", "/cart/add.js", true);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(
        JSON.stringify({
          attributes: {
            /*Special: "Product Special",*/
          },
          items: items,
        })
      );

      //document.querySelector("button.btn.product-form__cart-submit").click();
    });
    if (document.getElementsByClassName("ingridents-show-more-toggle").length > 0) {
      document.getElementsByClassName("ingridents-show-more-toggle")[0].addEventListener("click", function () {
        document.getElementsByClassName("ingredients__list")[0].classList.add("dropped");
        this.remove();
      });
    }
    var subQtys = document.querySelectorAll('.is-sub [name="quantity"]');
    subQtys.forEach((qty) => {
      qty.addEventListener("click", function () {
        var value = Number(this.value);
        var factor = 30;
        if (meta.product.variants[0].id == 42887457145008) {
          factor = 60;
        }
        document.getElementById("delivery-freq").value = value * factor;
      });
    });
    // document.querySelector("#yes-sub").addEventListener("click", function(){
    //   document.querySelector(`[value="sub"]`).click()
    // });
    // document.querySelector("#yes-otp").addEventListener("click", function(){
    //   document.querySelector(`#addToCart`).click()
    // });
  },
  scrollToReviews: () => {
    if (document.getElementById("backToTop")) {
      document.getElementById("backToTop").addEventListener("click", function (ev) {
        ev.preventDefault();
        BetterVits.isSafari && BetterVits.iOS
          ? document.getElementById("shopify-section-product-atf").scrollIntoView(true)
          : document.getElementById("shopify-section-product-atf").scrollIntoView({
              behavior: "smooth",
            });
      });
    }
    if (document.getElementById("scrollToTestimonials")) {
      document.querySelectorAll(".product-info a.button.secondary.small").forEach((button) => {
        button.addEventListener("click", function (ev) {
          ev.preventDefault();
          BetterVits.isSafari && BetterVits.iOS
            ? document.getElementById("testimonials").scrollIntoView(true)
            : document.getElementById("testimonials").scrollIntoView({
                behavior: "smooth",
              });
        });
      });

      document.getElementById("scrollToTestimonials").addEventListener("click", function (ev) {
        ev.preventDefault();
        BetterVits.isSafari && BetterVits.iOS
          ? document.getElementById("testimonials").scrollIntoView(true)
          : document.getElementById("testimonials").scrollIntoView({
              behavior: "smooth",
            });
      });
    }
    if (document.getElementById("shopify-section-product-atf")) {
      var scrollTotops = document.querySelectorAll("#shopify-section-product-atf ~ section .button.primary");
      for (var j = 0; j < scrollTotops.length; j++) {
        scrollTotops[j].addEventListener("click", function (ev) {
          ev.preventDefault();
          BetterVits.isSafari && BetterVits.iOS
            ? document.getElementById("shopify-section-product-atf").scrollIntoView(true)
            : document.getElementById("shopify-section-product-atf").scrollIntoView({
                behavior: "smooth",
              });
        });
      }
    }
  },
  scrollEvents: () => {
    if (document.body.classList.contains("index")) {
      if (BetterVits.isElementInView(document.querySelector(".best-seller")) && !document.querySelector(".best-seller__white").classList.contains("active")) {
        document.querySelector(".best-seller__white").classList.add("active");
        setTimeout(function () {
          document.querySelector(".best-seller__leaf").classList.add("active");
        }, 600);
      }
      if (BetterVits.isElementInView(BetterVits.cornerElement) && !BetterVits.cornerElement.classList.contains("green-section--corner")) {
        BetterVits.cornerElement.classList.add("green-section--corner");
      }
    }
  },
  setTimeout: (el, delay, className) => {
    setTimeout(function () {
      el.classList.add(className);
    }, delay);
  },
  initReviews: () => {
    document.getElementById("submit").addEventListener("click", function (ev) {
      if (!document.getElementById("newReview").checkValidity()) return false;
      document.querySelector(".confirmation img").src = document.querySelector(".confirmation img").src;
      document.querySelector(".confirmation").classList.add("show");
      setTimeout(function () {
        document.querySelector(".reviews-modal").classList.remove("visible");
        document.querySelector(".confirmation").classList.remove("show");
      }, 2000);
    });
    var rateStars = document.getElementsByName("rating"),
      allReviews = document.querySelectorAll("[data-rating]"),
      readmores = document.querySelectorAll(".read-more");

    for (var s = 0; s < rateStars.length; s++) {
      if (!rateStars[s]) return false;
      rateStars[s].addEventListener("click", function (ev) {
        var rating = this.value;
        var filtered = document.querySelectorAll("[data-rating='" + rating + "']");
        for (var a = 0; a < allReviews.length; a++) {
          var item = allReviews[a];
          item.classList.add("hide-animate");
        }
        setTimeout(function () {
          for (var a = 0; a < allReviews.length; a++) {
            var item = allReviews[a];
            item.classList.remove("show");
            item.classList.remove("show-animate");
            item.classList.add("hide");
          }
          for (var f = 0; f < filtered.length; f++) {
            var item = filtered[f];
            item.classList.add("show");
            item.classList.remove("hide");
            item.classList.remove("hide-animate");
          }

          setTimeout(function () {
            for (var f = 0; f < filtered.length; f++) {
              var item = filtered[f];
              item.classList.add("show-animate");
            }
          }, 300);
        }, 300);

        if (filtered.length == 0) {
          document.querySelector(".reviews-list__footer").classList.add("hide");
        } else {
          document.querySelector(".reviews-list__footer").classList.remove("hide");
        }
      });
    }

    for (var r = 0; r < readmores.length; r++) {
      if (!readmores[r]) return false;
      readmores[r].addEventListener("click", function (ev) {
        ev.preventDefault();
        this.closest("p").classList.add("active");
        this.remove();
      });
    }
    var currentPage = 1;
    document.getElementById("appendMoreReviews").addEventListener("click", (ev) => {
      ev.preventDefault();
      currentPage = currentPage + 1;
      if (currentPage == 4) {
        document.getElementById("appendMoreReviews").remove();
      }
      document.getElementById("reviewsList").dataset.page = currentPage;
    });
    document.getElementById("leaveReview").addEventListener("click", (ev) => {
      ev.preventDefault();
      document.querySelector(".reviews-modal").classList.add("visible");
    });
    document.getElementById("closeModal").addEventListener("click", (ev) => {
      ev.preventDefault();
      document.querySelector(".reviews-modal").classList.remove("visible");
    });
  },
  initCart: () => {
    if (document.documentElement.classList.contains("emptyness")) {
      return false;
    }
    var pricing = document.querySelector(".final-price");
    var value = Number(pricing.innerText.replace(/[^0-9\.-]+/g, ""));
    var increments = document.getElementsByClassName("increment"),
      decrements = document.getElementsByClassName("decrement"),
      rows = document.querySelectorAll('[action="/cart"] li.cart-items__item:not(.cart-items__item--upsell)'),
      rogueRows = document.querySelectorAll("li.cart-items__item.offer"),
      regularRows = document.querySelectorAll("li.cart-items__item:not(.offer):not(.cart-items__item--upsell)");

    if (value <= 45) {
      // document.querySelector(".cart-header").classList.add("show");
    }

    if (rogueRows.length > 0 && regularRows.length == 0) {
      document.querySelector(".cart-items__item.cart-items__item--upsell").remove();
      document.querySelector('[action*="/cart"]').remove();

      var updateString = "updates[" + rogueRows[0].dataset.cartItemKey.split(":")[0] + "]=0";
      for (var i = 0; i < rogueRows.length; i++) {
        updateString = updateString + "&updates[" + rogueRows[i].dataset.cartItemKey.split(":")[0] + "]=0";
        rogueRows[i].remove();
      }

      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          location.reload();
        }
      };
      xhr.open("POST", "/cart/update.js", true);
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

      xhr.send(updateString);

      return false;
    }

    document.querySelector(".upsell__check").addEventListener("click", function (uc) {
      var isMulti = document.querySelector(".cart-items__item.cart-items__item--upsell.active").classList.contains("multivitamin");
      this.classList.toggle("active");
      pricing.innerText = "$" + (this.classList.contains("active") ? value + (isMulti ? 16.99 : 25) : value).toFixed(2) + " USD";
    });

    for (var i = 0; i < increments.length; i++) {
      increments[i].addEventListener("click", function () {
        var parentTR = this.closest("li");
        if (parentTR.classList.contains("is-subscription") && Number(this.closest("div").querySelector(".cart__qty-input").value) >= 3) {
          parentTR.classList.add("limited");
        } else {
          this.closest("div").querySelector(".cart__qty-input").stepUp();
        }
      });
    }

    for (var d = 0; d < decrements.length; d++) {
      decrements[d].addEventListener("click", function () {
        this.closest("li").classList.remove("limited");
        this.closest("div").querySelector(".cart__qty-input").stepDown();
      });
    }
    for (var r = 0; r < rows.length; r++) {
      rows[r].querySelector(".remove-line").addEventListener("click", function (ev) {
        ev.preventDefault;
        ev.stopPropagation();
        var rowVariant = this.dataset.variant;
        var hasPretenders = document.querySelectorAll("[data-cart-item-props='" + rowVariant + "0']");
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            setTimeout(function () {
              location.reload();
            }, 300);
          }
        };
        xhr.open("POST", "/cart/update.js", true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        var updateString = "updates[" + rowVariant + "]=0";
        if (hasPretenders.length > 0) {
          for (var p = 0; p < hasPretenders.length; p++) {
            updateString = updateString + "&updates[" + hasPretenders[p].dataset.cartItemVariant + "]=0";
          }
        }
        xhr.send(updateString);
      });
    }
    if (document.querySelectorAll('[data-cart-item-variant="45005138526516"]').length == 1 && document.querySelectorAll("[data-cart-item-variant]").length == 1) {
      BetterVits.cartUpsellInit(1, { id: 8256506200372, variants: [{ id: 45005138297140 }] }, true);
    } else {
      // if (document.querySelectorAll('[data-cart-item-variant="45005138297140"]').length == 0) {
      //    BetterVits.cartUpsellInit(1, { id: 8256506102068, variants: [{ id: 45005138264372 }] }, true);
      //  } else {
      var xmlhttp = new XMLHttpRequest(),
        smallest = 100,
        upsellItem = {};
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == XMLHttpRequest.DONE) {
          if (xmlhttp.status == 200) {
            var itemsArray = JSON.parse(xmlhttp.responseText).items;

            for (var productItem in itemsArray) {
              var quantity = itemsArray[productItem].quantity;
              if (quantity < smallest && !Object.values(BetterVits.getDiscountedProductVariant).includes(itemsArray[productItem].id)) {
                smallest = quantity;
                upsellItem = itemsArray[productItem];
              }
            }
            BetterVits.cartUpsellInit(
              1,
              {
                id: upsellItem.product_id,
                variants: [{ id: upsellItem.id }],
              },
              true
            );
          } else if (xmlhttp.status == 400) {
            alert("There was an error 400");
          } else {
            alert("something else other than 200 was returned");
          }
        }
      };

      xmlhttp.open("GET", "/cart.js", true);
      xmlhttp.send();
      //}
    }
  },
  setCookie: function (cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  },
  getCookie: function (cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },
  initNotification: function () {
    var notificationEl = document.getElementById("bettervits-notification");
    if (notificationEl.innerText.trim().length > 10) {
      let notification = BetterVits.getCookie("notification");
      if (notification !== "true") {
        notificationEl.classList.remove("inactive");
        document.getElementById("PageContainer").classList.add("has-notification");
      }
      document.getElementById("close-notification").addEventListener("click", function () {
        BetterVits.setCookie("notification", "true", 10);
        notificationEl.classList.add("inactive");
        document.getElementById("PageContainer").classList.remove("has-notification");
      });
    }
  },
  reChargeChecker: function () {
    var rechargeAppeared = false;
    var recharges = document.querySelectorAll("li.is-sub");
    for (var j = 0; j < recharges.length; j++) {
      recharges[j].setAttribute("disabled", "disabled");
    }

    for (var j = 0; j < recharges.length; j++) {
      recharges[j].removeAttribute("disabled");
    }
    document.querySelector(".product-info").classList.add("present");
    document.querySelector(".product-info [name='type']").dispatchEvent(new Event("change"));
  },
  upsellToggles: function () {
    var upsellToggles = document.querySelectorAll(".upsellToSub__input");
    for (var j = 0; j < upsellToggles.length; j++) {
      upsellToggles[j].addEventListener("change", function () {
        var controls = this.closest("li").querySelectorAll("label.upsellToSub");

        [].forEach.call(controls, (el) => {
          el.classList.add("active");
        });

        var theVariant = this.value.split(":")[0],
          qty = this.dataset.qty;
        var xhr = new XMLHttpRequest();
        var isOffer = this.closest("li").classList.contains("offer");
        var index = parseInt(this.closest("label").querySelector(".delfreq").value) / 30 - 1;
        var sP = isOffer ? BetterVits.offersSellingPlans[theVariant][index] : BetterVits.productsSelingPlans[theVariant][index];
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            var xhrSUB = new XMLHttpRequest();
            xhrSUB.onreadystatechange = function () {
              if (xhrSUB.readyState == 4 && xhrSUB.status == 200) {
                window.location.href = "/cart";
              }
            };
            xhrSUB.open("POST", "/cart/add.js", true);
            xhrSUB.setRequestHeader("Content-Type", "application/json");
            xhrSUB.send(
              JSON.stringify({
                items: [
                  {
                    quantity: qty,
                    id: theVariant,
                    selling_plan: sP,
                  },
                ],
              })
            );
          }
        };
        xhr.open("POST", "/cart/change.js", true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.send("line=" + this.closest("li").dataset.cartItemIndex + "&quantity=0");
      });
    }
  },
  insertAfter: function (newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
  },
  insertBefore: function (newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode);
  },
  createElementFromHTML: function (htmlString) {
    var div = document.createElement("div");
    div.innerHTML = htmlString.trim();

    // Change this to div.childNodes to support multiple top-level nodes
    return div.firstChild;
  },
  rewordReCharge: function () {
    var root = document.querySelector("section.rc-login");
    var customer =
      BetterVits.getCookie("BV_subscription_customer").length > 5
        ? JSON.parse(BetterVits.getCookie("BV_subscription_customer"))
        : JSON.parse(JSON.stringify({ isSub: false, email: "" }));
    var isSub = customer.isSub,
      customerEmail = customer.email;
    document.body.classList.add("recharge-login");
    var sectionTitle = document.querySelector("section.rc-login").querySelector("h1.rc-login--header-title");
    var sectionBody = document.querySelector("section.rc-login").querySelector("label.rc-login-form-label");
    if (sectionBody) {
      if (isSub && !!document.getElementById("rc-email")) {
        document.getElementById("rc-email").value = customerEmail;
        //document.getElementById("login_verification").submit();
        sectionTitle.innerText = "Access Subscription";
        document.querySelector("button.rc-login-form-button.animated span").innerText = "Send Login Link (Email & SMS)";

        sectionBody.innerText = "We have detected a subscription account with this e-mail. Click 'Submit' to get access to your account.";
      } else {
        document.querySelector("button.rc-login-form-button.animated span").innerText = "Send Login Link (Email & SMS)";
        sectionTitle.innerText = "Access Subscription";
        sectionBody.innerHTML = "Please enter <b>the email you used for your order</b> to access your subscription.";
        BetterVits.insertAfter(
          BetterVits.createElementFromHTML(`<div style="font-size: 12px;padding: 0 2rem;text-align: center;color: #123840;"><br><h4 style="
          font-size: 18px;
          margin: 0rem 0 16px 0;
      ">Need Help?</h4>You may access your subscription using this page to modify your delivery frequency or cancel your subscription. In order to gain access, please ensure you are using the same email you placed your initial order with.
          <br>

             <br>
          <b>If you need help managing your subscription, please <a href="/pages/contact-us">Contact Us Here</a>. We're happy to help you manage your subscription as needed.</b></div>`),
          document.querySelector(".rc-login--body")
        );
        root.style.opacity = 1;
      }
    } else {
      if (isSub) {
        sectionBody.innerHTML = `
        We have sent you an e-mail to: <b>${customerEmail}</b><br>
        Please check your inbox (including spam) for a link to access your subscription.
        `;
      }
      root.style.opacity = 1;
    }
  },
  initFloaterATC: function () {
    var el = document.querySelector(".floater-atc"),
      atcElement = document.getElementById("addToCart"),
      atcPosition = window.scrollY + atcElement.getBoundingClientRect().top;
    el.addEventListener("click", function () {
      if (atcElement.getAttribute("disabled") == null) {
        atcElement.click();
      } else {
        document.querySelector(".green-section__cell .button.primary").click();
      }
    });
    window.onscroll = function () {
      if (window.scrollY > atcPosition) {
        el.classList.add("active");
      } else {
        el.classList.remove("active");
      }
    };
  },
  calculateVH: function () {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", vh + "px");
  },
  initGeoIPdetection: function () {
    let cookiePresent = BetterVits.getCookie("geoIPRedirect");
    if (cookiePresent == "leave") {
      window.location.href = "https://bettervits.co.uk";
    }
    if (cookiePresent.length > 0) {
      return false;
    }

    var detectCountry = function (geoipResponse) {
      var countryCode = geoipResponse.country.iso_code || "US";
      if (countryCode == "GB") {
        document.getElementById("geoip-banner").classList.add("active");
        document.querySelectorAll(".choices").forEach((choice) => {
          choice.addEventListener("click", function (ev) {
            ev.preventDefault();
            var selection = choice.id;
            BetterVits.setCookie("geoIPRedirect", selection, 1);
            document.getElementById("geoip-banner").classList.remove("active");
            if (selection == "leave") {
              window.location.href = choice.href;
            }
          });
        });
      }
      console.log("GeoIP response:");
      console.log(geoipResponse);
    };

    var onSuccess = function (geoipResponse) {
      detectCountry(geoipResponse);
    };

    // If we get an error, we will display an error message
    var onError = function (error) {
      document.getElementById("geoip-banner").innerHTML = "an error!  Please try again..";
    };

    if (typeof geoip2 !== "undefined") {
      geoip2.country(onSuccess, onError);
    } else {
      document.querySelector("#geoip-banner p").innerHTML = "You're using a browser that blocks GeoIP2 requests";
    }
  },
  openOTPModal: function() {
    fetch(`${window.location.pathname}?section_id=otp-modal`)
        .then(res => res.text())
        .then(html => {
          // Parse and extract just the modal section content
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const modalContent = doc.querySelector('#shopify-section-otp-modal');

          if (modalContent) {
            document.querySelector('#modal-container').innerHTML = modalContent.innerHTML;
            // Show the modal
            document.querySelector('#modal-container').classList.add('open');

            document.querySelector('body').style.overflow = "hidden"

            document.querySelector("#yes-sub").addEventListener("click", function(ev){
              ev.preventDefault();
              console.log('clicked 2')
              document.querySelector(`[value="sub"]`).click()
              document.querySelector('body').style.overflow = '';
            document.querySelector('#modal-container').innerHTML = "";
            document.querySelector('#modal-container').classList.remove('open');
            });
            document.querySelector("#yes-otp").addEventListener("click", function(ev){
              ev.preventDefault();
              // console.log(SlideOutCart)
              document.querySelector(`#addToCart`).click()
            });

            BetterVits.closeOTPModal();
          }
        })
        .catch(err => console.error('Error loading modal:', err));
  },
  closeOTPModal: function() {
    document.querySelector('[data-modal-close]').addEventListener('click', function() {
      document.querySelector('body').style.overflow = '';
      document.querySelector('#modal-container').innerHTML = "";
      document.querySelector('#modal-container').classList.remove('open');
    })
  },
  updateIncentive(number) {
    var unlockValue = 3 - Number(number);

    if (unlockValue <= 0){
       document.querySelector(".progress p").innerHTML = `Discount unlocked!`;           
    } else {
       document.querySelector(".progress p").innerHTML = `Add <b id="howmanyp">0</b> more products to your cart to <b>unlock 15% off</>.`;
       document.querySelector(".progress #howmanyp").innerText = unlockValue;
    }

    document.querySelector(".progress .bar span").style.width = `${(Number(number) / 3) * 100}%`;
  }
};

BetterVits.calculateVH();
window.addEventListener("orientationchange", BetterVits.calculateVH);

if (document.body.classList.contains("template-")) {
  BetterVits.rewordReCharge();
}

if (document.body.classList.contains("product")) {
  BetterVits.scrollToReviews();
  BetterVits.initQtySelector();
  BetterVits.reChargeChecker();
}

if (document.body.classList.contains("cart")) {
  BetterVits.initCart();
  BetterVits.upsellToggles();
}
if (document.body.classList.contains("reviews")) {
   BetterVits.initReviews();
}

window.onscroll = function () {
  BetterVits.customSticky();
  BetterVits.scrollEvents();
};

if (document.body.classList.contains("product")) {
  BetterVits.initFloaterATC();
}

BetterVits.initCarsousels();
BetterVits.customSticky();
BetterVits.initMobileMenu();
BetterVits.initFAQ();
BetterVits.initNotification();
BetterVits.initGeoIPdetection();
